import {Directive, Injector, Input, Optional} from '@angular/core';

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  register,
  styler,
  APPLY_STYLES_TYPE,
  getWidgetRegistry
} from "@wm/components-base";
import { runtimeEventManager } from "@wm/core";
const DEFAULT_CLS = 'app-grid-layout clearfix';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-layoutgrid',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmLayoutGrid]',
  providers: [
  provideAsWidgetRef(LayoutGridDirective)
  ],
  standalone: true,
  exportAs: 'wmLayoutGrid'
})
export class LayoutGridDirective extends StylableComponent {
  static initializeProps = register('wm-layoutgrid');
  private dynamicComponentProvider: any;
  private prepareElements: any;
  private markupManagerService: any;
  private initialized: boolean = false;

  constructor(inj: Injector, @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    styler(this.nativeElement, this, APPLY_STYLES_TYPE.CONTAINER);
    this.dynamicComponentProvider = runtimeEventManager.getService('dynamicComponentProvider');
    this.prepareElements = runtimeEventManager.getService('componentRefProvider').prepareElements;
    this.markupManagerService = runtimeEventManager.getService('markupManager');

    this.registerReadyStateListener(() => {
      this.initialized = true;
    });
  }

  protected override onPropertyChange(key: string, nv: any, ov?: any) {
    if (!this.initialized) {
      return;
    }
    if (key === "columns") {
      this.getUpdatedLayoutgridColumns(nv, ov);
    }
    super.onPropertyChange(key, nv, ov);
  }

  protected getUpdatedLayoutgridColumns(colsPerRow: any, ov?: any) {
    var layoutGridMarkup: any, existingRows, existingCols: any, requiredRows,
        _html: any = '<div>', count = 0, colWidth = 12 / colsPerRow,
        markUp = this.markupManagerService.getMarkup();

    layoutGridMarkup = markUp.find('[widgetid=' + (<any>this).widgetId + ']');
    existingRows = layoutGridMarkup.find('> wm-gridrow');
    existingCols = existingRows.find('> wm-gridcolumn')
    requiredRows = existingCols && Math.ceil(existingCols.length / colsPerRow);

    // construct the markup based on the required rows and cols.
    this.getRangeArr(requiredRows)?.forEach(() => {
      _html += '<wm-gridrow>';
      this.getRangeArr(colsPerRow).forEach(() => {
        _html += '<wm-gridcolumn columnwidth=' + colWidth + '>';
        if (count < existingCols.length) {
          _html += existingCols.eq(count).html();
          count++
        }
        _html += '</wm-gridcolumn>';
      });
      _html += '</wm-gridrow>';
    })
    _html += '</div>';
    _html = $(_html);
    // prepare the markup
    this.prepareElements($(_html));
    // update the layout grid in the markup
    layoutGridMarkup.html(_html.html());
    _html = '<div>' + _html.html() + '</div>';
    this?.dynamicComponentProvider?.addComponentBasedOnSelector(null, _html, {}, {}).then((el: HTMLElement) => {
      this.updateCanvasGridLayout(el);
    });
  }

  updateCanvasGridLayout(el: HTMLElement) {
    //remove exisiting row & columns from gridLayout
    while (this?.nativeElement?.firstChild) {
      this.nativeElement.removeChild(this.nativeElement.firstChild);
    }

    //append newly constructed rows & cols to gridLayout
    let childrenElementLength = el.children.length;
    for (let i = 0; i < childrenElementLength; i++) {
      this.nativeElement.appendChild(el.children[0]);
    }
  }

  getRangeArr(rangeValue: number){
    let arr = [];
    for (let i = 0; i < rangeValue; i++) {
      arr.push(i)
    }
    return arr;
  }
}

